import Sidebar from "../../components/Sidebar/Sidebar";

export default function Main() {
  return (
    <>
        <Sidebar />
    </>
  );
}
